import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Public entry point the marketing site links to:
 *   {APP_URL}/referrals?type=talent   → talent referral page
 *   {APP_URL}/referrals?type=business → client/brand referral page
 * ProtectedRoute (wrapping this route) bounces guests to /login first and
 * restores the destination after auth. Once authenticated we route by the
 * user's real role; the ?type= param is only a fallback hint.
 */
const ReferralEntry = () => {
  const { user, loading } = useAuth();
  const [params] = useSearchParams();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-500" data-testid="referral-entry-loading"></div>
      </div>
    );
  }

  const type = (params.get('type') || '').toLowerCase();
  const role = user?.role;

  if (role === 'talent') return <Navigate to="/talent/referrals" replace />;
  if (role === 'client' || role === 'agency') return <Navigate to="/client/referrals" replace />;
  if (role === 'admin' || role === 'super_admin') return <Navigate to="/admin/referrals" replace />;

  // Fallback to the ?type= hint if role is unknown.
  if (type === 'business' || type === 'brand' || type === 'client') return <Navigate to="/client/referrals" replace />;
  return <Navigate to="/talent/referrals" replace />;
};

export default ReferralEntry;
